import dayjs from 'dayjs';
import { IDeviceTruckImplement } from 'app/shared/model/device-truck-implement.model';
import { TruckDeviceLockStatus } from 'app/shared/model/enumerations/truck-device-lock-status.model';

export interface ITruckDeviceStatus {
  id?: number;
  created?: string;
  status?: TruckDeviceLockStatus;
  deviceTruckImplement?: IDeviceTruckImplement | null;
}

export const defaultValue: Readonly<ITruckDeviceStatus> = {};
